import { Box, Modal, Typography } from '@mui/material';
import Input from 'components/Common/Input';
import { useForm } from 'react-hook-form';
import Button from 'components/Common/Button';
import { useNavigate } from 'react-router-dom';
import { useAddColumn } from 'apis/business/agent/worksheet/hook';

export default function CreateColumnForm() {
  const navigate = useNavigate();
  const { mutateAsync: handleAddColumn, isPending } = useAddColumn();

  const { handleSubmit, control } = useForm({});

  const onSubmit = async (data: any) => {
    const columnData = {
      column: {
        name: data?.column?.name,
        data_type: 'string'
      }
    };
    await handleAddColumn(columnData);
  };

  return (
    <Modal
      open={true}
      onClose={() => navigate(-1)}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Typography variant='h6'>Add Column</Typography>
        <Box component='form' onSubmit={handleSubmit(onSubmit)} mt={2}>
          <Input name='column.name' label='Name' control={control} fullWidth required />

          <Box display='flex' justifyContent='end' gap={2} mt={2}>
            <Button
              onClick={() => navigate(-1)}
              color='secondary'
              variant='outlined'
              sx={{ border: '1px solid #F3F3F3' }}
            >
              Cancel
            </Button>
            <Button type='submit' variant='contained' isPending={isPending}>
              Add
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  padding: '16px 24px',
  border: '1px solid #F3F3F3',
  boxShadow: 24,
  borderRadius: '8px',
  width: {
    xs: '90%',
    sm: 400,
    md: 500
  }
};
